export default [
	{
		path: '/admin/smg-activity-logs',
		name: 'smg-activity-log',
		meta: { requiresAuth: true },
		component: () => import('@/pages/customer-service/smg-activity-log/index.vue')
	},
]